/**
 * Kod wygenerowany automatycznie przez automatyczne narz�dzie (problemy zg�asza� do Tomasza Grze�kiewicza)
 * nie zmieniaj tego pliku, wszystkie zmiany zostan� nadpisane automatycznie
 */
import {Api} from "../index";
import {ReactivityValidator} from "../../utils/ReactivityValidator"

export const AgencyTaskAccreditationCountry = {

	getAvailableCountries (context, contestId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-task-accreditation-country/available-countries"
			+ "?contestId=" + contestId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

	getAvailableCountriesForAgency (context, contestId, agencyId, onSuccess, onError, options) {
		Api.get(context,
			"/agency-task-accreditation-country/available-countries-for-agency"
			+ "?contestId=" + contestId
			+ "&agencyId=" + agencyId
			,(response) => {if ((typeof onSuccess) === 'function') { onSuccess(response); ReactivityValidator.validate(context);}}
			,onError
			,options);
	},

};
